// generated by the plop

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { cloneDeep } from 'lodash';
import { CreatedDebtByWS, DebtModel, DebtService, UpdatedDebtByWS } from 'shared';
import { PROGRESS_STATUSES } from 'symbols';
import {
  DeleteLocalDebt,
  GetDebtById,
  GetDebtByIdFail,
  GetDebtByIdSuccess,
  SetCurrentDebtId,
  UpdateDebt,
  UpdateDebtFail,
  UpdateDebtSuccess,
  UpdateLocalDebt
} from './stand-manage.actions';
import { DEBT_MANAGE_STATE_DEFAULT, DebtManageStateModel } from './stand-manage.model';

@State({ name: 'DebtManage', defaults: DEBT_MANAGE_STATE_DEFAULT })
@Injectable()
export class DebtManageState {

  constructor(private debtService: DebtService) {
  }


  @Selector()
  static realVersionDebt(state: DebtManageStateModel): DebtManageStateModel['realVersionDebts'] {
    return state.realVersionDebts;
  }

  @Selector()
  static currentDebt(state: DebtManageStateModel): DebtModel {
    return state.debts?.[state.currentDebtId];
  }

  @Selector()
  static loadDebtStatus(state: DebtManageStateModel): PROGRESS_STATUSES {
    return state.loadDebtStatus;
  }


  @Action(GetDebtById)
  getDebtById(ctx: StateContext<DebtManageStateModel>, { id }: GetDebtById): void {
    ctx.patchState({
      loadDebtStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    if (ctx.getState().debts?.[id]) {
      this.debtService.getDebtById(id).subscribe({
        next: debt => {
          ctx.dispatch(new UpdatedDebtByWS(debt));
          ctx.patchState({
            currentDebtId: id
          });
        },
        error: err => ctx.dispatch(new GetDebtByIdFail(err))
      });

    } else {
      this.debtService.getDebtById(id).subscribe({
        next: debt => ctx.dispatch(new GetDebtByIdSuccess(debt)),
        error: err => ctx.dispatch(new GetDebtByIdFail(err))
      });
    }
  }

  @Action(GetDebtByIdSuccess)
  getDebtByIdSuccess(ctx: StateContext<DebtManageStateModel>, { debt }: GetDebtByIdSuccess): void {
    const debts = cloneDeep(ctx.getState().debts);
    debts[debt.id] = debt;
    ctx.patchState({
      debts,
      currentDebtId: debt.id,
      loadDebtStatus: PROGRESS_STATUSES.SUCCESS
    });
  }

  @Action(GetDebtByIdFail)
  getDebtByIdFail(ctx: StateContext<DebtManageStateModel>, { error }: GetDebtByIdFail): void {
    ctx.patchState({
      loadDebtStatus: PROGRESS_STATUSES.FAIL
    });
  }

  @Action(SetCurrentDebtId)
  setCurrentDebtId(ctx: StateContext<DebtManageStateModel>, { id }: SetCurrentDebtId): void {
    ctx.patchState({
      currentDebtId: id
    });
  }

  @Action(UpdateLocalDebt)
  updateLocalDebt(ctx: StateContext<DebtManageStateModel>, { debt }: UpdateLocalDebt): void {
    const debts = cloneDeep(ctx.getState().debts);
    debts[debt.id] = { ...debts[debt.id], ...debt };
    ctx.patchState({
      debts
    });
  }

  @Action(DeleteLocalDebt)
  deleteLocalDebt(ctx: StateContext<DebtManageStateModel>, { id }: DeleteLocalDebt): void {
    const debts = cloneDeep(ctx.getState().debts);
    const realVersionDebts = cloneDeep(ctx.getState().realVersionDebts);

    delete debts[id];
    delete realVersionDebts[id];
    ctx.patchState({
      debts,
      realVersionDebts
    });
  }


  @Action(UpdateDebt)
  updateDebt(ctx: StateContext<DebtManageStateModel>, { id, debt, force }: UpdateDebt): void {
    ctx.patchState({
      updateDebtStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.debtService.updateDebt(id, debt, force).subscribe({
      next: updatedDebt => ctx.dispatch(new UpdateDebtSuccess(updatedDebt)),
      error: err => ctx.dispatch(new UpdateDebtFail(err))
    });
  }

  @Action(UpdateDebtSuccess)
  updateDebtSuccess(ctx: StateContext<DebtManageStateModel>, { debt }: UpdateDebtSuccess): void {
    ctx.patchState({
      updateDebtStatus: PROGRESS_STATUSES.SUCCESS
    });
  }

  @Action([UpdatedDebtByWS])
  updateDebtByWS(ctx: StateContext<DebtManageStateModel>, { debt }: UpdatedDebtByWS): void {
    const realVersionDebts = cloneDeep(ctx.getState().realVersionDebts);
    ctx.patchState({
      loadDebtStatus: PROGRESS_STATUSES.SUCCESS,
      realVersionDebts: { ...realVersionDebts, [debt.id]: debt }
    });
  }

  @Action(CreatedDebtByWS)
  createdDebtByWS(ctx: StateContext<DebtManageStateModel>, { debt }: CreatedDebtByWS): void {
    const debts = cloneDeep(ctx.getState().debts);
    ctx.patchState({
      debts: {
        ...debts,
        [debt.id]: {
          ...debts[debt.id],
          isChanged: false,
          updater: debt.updater
        }
      }
    });
  }

}




